


































































import { Component, Vue } from 'vue-property-decorator'
import HeaderNavigationDropdown from '@/components/layout/header/navigation/HeaderNavigationDropdown.vue'
import RouteName from '@/utils/RouteName'
import TranslationModule from '@/utils/TranslationModule'
import HeaderNavigationItemTitle from '@/components/layout/header/navigation/HeaderNavigationItemTitle.vue'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
import { Member } from '@/types/Member.type'
import { namespace } from 'vuex-class'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'

const User = namespace('user')

@Component({
    components: { EvaIcon, HeaderNavigationItemTitle, HeaderNavigationDropdown, BaseIcon },
})
export default class HeaderEventNavigation extends Vue {
    @User.State me!: Member
    RouteName: typeof RouteName = RouteName
    TranslationModule: typeof TranslationModule = TranslationModule

    meetingLinks = [
        { id: 'physical', route: { name: RouteName.EVENTS, query: { type: 'physical' } } },
        { id: 'live', route: { name: RouteName.EVENTS, query: { type: 'live' } } },
    ]

    cityLinks = [
        {
            icon: 'new-york',
            name: 'New York',
            route: {
                name: RouteName.EVENTS,
                query: {
                    city: 'New York',
                },
            },
        },
        {
            icon: 'paris',
            name: 'Paris',
            route: {
                name: RouteName.EVENTS,
                query: {
                    city: 'Paris',
                },
            },
        },
        {
            icon: 'londres',
            name: 'Londres',
            route: {
                name: RouteName.EVENTS,
                query: {
                    city: 'Londres',
                },
            },
        },
        {
            icon: 'madrid',
            name: 'Madrid',
            route: {
                name: RouteName.EVENTS,
                query: {
                    city: 'Madrid',
                },
            },
        },
        {
            icon: 'hong-kong',
            name: 'Hong Kong',
            route: {
                name: RouteName.EVENTS,
                query: {
                    city: 'Hong Kong',
                },
            },
        },
    ]

    get cityList() {
        return this.cityLinks.map(c => c.name)
    }

    get myCity() {
        if (this.me) {
            if (this.me.location?.geoloc?.location?.city || this.me.location?.geoloc?.location?.formatted_address) {
                return this.me.location?.geoloc?.location?.city || this.me.location?.geoloc?.location?.formatted_address
            } else {
                return this.me.city
            }
        } else {
            return null
        }
    }
    selectCity(city: string) {
        this.$store.commit('event/SET_SEARCH_PARAMETERS', {
            searchParameters: {
                ...this.$store.state.event.searchParameters,
                city,
            },
        })
    }

    selectType(type: string) {
        this.$store.commit('event/SET_SEARCH_EVENT_TYPE_FILTER', { eventTypeFilter: type })
    }

    resetEvents() {
        if (this.$route.name === RouteName.EVENTS) this.$emit('close')
        this.$root.$emit('resetEvents')
    }
}
